@if (ftpInfo && currentUser) {
  <div class="row">
    <div class="col-12 col-md-8 col-lg-7">
      <div class="border border-opacity-50 border-secondary mt-3 p-3 rounded">
        <h5 class="text-primary">{{ "Template.MainComponent.label_ftpCredentials" | translate }}:</h5>
        <table class="table table-bordered mt-1">
          <tbody>
            <tr>
              <td>{{ "Template.MainComponent.label_protocol" | translate }}:</td>
              <td><strong>SFTP</strong></td>
            </tr>
            <tr class="align-middle">
              <td>{{ "Template.MainComponent.label_host" | translate }}:</td>
              <td>
                <strong class="d-inline-block py-1">{{ ftpInfo.host }}</strong>
                <button type="button" class="btn btn-outline-primary btn-sm float-end" tabindex="0" (click)="copyToClipBoard($event, ftpInfo.host)" ngbTooltip="{{ 'Common.copyToClipboard' | translate }}">
                  <fa-icon icon="clipboard" class="far"></fa-icon>
                </button>
              </td>
            </tr>
            <tr class="align-middle">
              <td>{{ "Template.MainComponent.label_port" | translate }}:</td>
              <td>
                <strong class="d-inline-block py-1">{{ ftpInfo.port }}</strong>
                <button type="button" class="btn btn-outline-primary btn-sm float-end" tabindex="0" (click)="copyToClipBoard($event, ftpInfo.port)" ngbTooltip="{{ 'Common.copyToClipboard' | translate }}">
                  <fa-icon icon="clipboard" class="far"></fa-icon>
                </button>
              </td>
            </tr>
            <tr class="align-middle">
              <td>{{ "Template.MainComponent.label_username" | translate }}:</td>
              <td>
                <strong class="d-inline-block py-1">{{ currentUser.email! }}</strong>
                <button type="button" class="btn btn-outline-primary btn-sm float-end" tabindex="0" (click)="copyToClipBoard($event, currentUser.email!)" ngbTooltip="{{ 'Common.copyToClipboard' | translate }}">
                  <fa-icon icon="clipboard" class="far"></fa-icon>
                </button>
              </td>
            </tr>
            <tr class="align-middle">
              <td>
                {{ "Template.MainComponent.label_password" | translate }}:
                @if (currentUser?.externalAuthId) {
                  <fa-icon icon="info-circle" class="text-primary" placement="top" ngbTooltip="{{ 'Template.DataManagementFtpComponent.tooltip_ftpPasswordIndependent' | translate }}"></fa-icon>
                }
              </td>
              <td>
                @if (!currentUser?.externalAuthId) {
                  <div class="align-middle">
                    <em>{{ "Template.MainComponent.label_personalPassword" | translate }}</em>
                  </div>
                }
                @if (currentUser?.externalAuthId) {
                  <div>
                    <div class="d-flex flex-row justify-content-between">
                      <strong class="align-content-center">{{ currentUser.ftpPassword }}</strong>
                      <button type="button" class="btn btn-outline-primary btn-sm" tabindex="0" (click)="copyToClipBoard($event, currentUser.ftpPassword!)" ngbTooltip="{{ 'Common.copyToClipboard' | translate }}">
                        <fa-icon icon="clipboard" class="far"></fa-icon>
                      </button>
                    </div>
                    <hr class="my-2" />
                    <button class="btn btn-outline-danger btn-sm d-block w-100" (click)="resetFtpPassword()" [disabled]="resettingFtpPassword">
                      <fa-icon icon="key" class="me-1"></fa-icon>
                      {{ "Template.DataManagementFtpComponent.btn_changeFtpPassword" | translate }}
                      @if (resettingFtpPassword) {
                        <fa-icon icon="spinner" animation="spin" class="ms-1"></fa-icon>
                      }
                    </button>
                  </div>
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
}
